'use client';

import dynamic from 'next/dynamic';

// `ssr: false` is only legal inside a Client Component — Next refuses it
// directly in a Server Component (layout.tsx is one). This thin wrapper
// exists solely so the root layout can mount PostHogInit without pulling
// posthog-js into the shared/initial bundle: it becomes its own chunk,
// fetched only after hydration.
const PostHogInit = dynamic(() => import('./posthog-init').then((m) => m.PostHogInit), {
  ssr: false,
});

export function PostHogLoader() {
  return <PostHogInit />;
}
